import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword } from "../../../redux/authSlice";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, message } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      return toast.error("Please enter a valid email address");
    }

    try {
      const res = await dispatch(forgotPassword(email));

      if (res.payload?.message) {
        toast.success(res.payload.message);
        navigate("/login");
      } else if (res.payload?.error) {
        toast.error(res.payload.error);
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <section>
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Row className="p-4 shadow-lg rounded-4 bg-light" style={{ width: '100%', maxWidth: '400px' }}>
          <Col xxl={12}>
            <h2 className="mb-3 text-center">Forgot Password?</h2>
            {error && <Alert variant="danger">{typeof error === "string" ? error : error.error}</Alert>}
            {message && <Alert variant="danger">{typeof message === "string" ? message : message.message}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : "Recover Password"}
              </Button>
            </Form>
          </Col>

          <Col xxl={12}>
            <div className="mt-3 text-center">
              <Link to="/login" className="mb-2 d-block">Back to Login</Link>
              <span>Don't have an account? </span>
              <Link to="/signup">Sign Up</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ForgotPassword;
